import React from 'react';
import { Route } from 'react-router-dom';
import Layout from '../../../Layout/index';
import Commerce from './Commerce';
import Crypto from './Crypto';
import Documentation from './Documentation';
import DefaultPages from './DefaultPages';
import Account from './Account';
import ECommerce from './ECommerce';
import Maps from './Maps';
import Charts from './Charts';
import Tables from './Tables';
import Forms from './Forms';
import Upload from './Upload';
import PutAway from './PutAway';
import Receiving from './Receiving';
import SecondaryUpload from './SecondaryUpload';
import CycleCount from './CycleCount';
import ReportsForm from './Reports';
import History from './History';
import ProductIT from './ProductIT';
import StockMovement from './StockMovement';
import Picking from './Picking';
import Binconsolidation from './Maintenance';
import UI from './UI';

import Chat from '../../../Chat/index';
import Todo from '../../../Todo/index';

import FastMovingLastDetail from '../../../Dashboards/Booking/components/FastMovingLastDetail';
import SlowMovingLastDetail from '../../../Dashboards/Booking/components/SlowMovingLastDetail';
import BinConsolidationCandidatesDetail from '../../../Dashboards/Booking/components/BinConsolidationCandidatesDetail';
import ShelfLifeDetail from '../../../Dashboards/Booking/components/ShelfLifeDetail';
import PickingProductivityDetail from '../../../Dashboards/Booking/components/PickingProductivityDetail';

import FitnessDashboard from '../../../Dashboards/Fitness/index';
import DefaultDashboard from '../../../Dashboards/Default/index';
import MISDashboard from '../../../Dashboards/MISDashboard/index';

import MobileAppDashboard from '../../../Dashboards/MobileApp/index';
import BookingDashboard from '../../../Dashboards/Booking/index';
import LocationSelection from '../../../Account/LocationSelection/index';
import InboundDashboard from '../../../Dashboards/InboundDashboard';

import Mail from '../../../Mail/index';

export default () => (
  <div>
    <Layout />
    <div className="container__wrap">
      <Route path="/dashboard_default" component={DefaultDashboard} />
      <Route path="/inbound_dashboard" component={InboundDashboard} />
      <Route path="/location_selection" component={LocationSelection} />
      <Route path="/dashboard_mis" component={MISDashboard} />
      <Route path="/dashboard_e_commerce" component={Commerce} />
      <Route path="/dashboard_fitness" component={FitnessDashboard} />
      <Route path="/dashboard_crypto" component={Crypto} />
      <Route exact path="/dashboard_mobile_app" component={MobileAppDashboard} />
      <Route path="/dashboard_booking" component={BookingDashboard} />
      <Route path="/ui" component={UI} />
      <Route path="/mail" component={Mail} />
      <Route path="/chat" component={Chat} />
      <Route path="/todo" component={Todo} />
      <Route path="/forms" component={Forms} />
      <Route path="/upload" component={Upload} />
      <Route path="/putaway" component={PutAway} />
      <Route path="/receiving" component={Receiving} />
      <Route path="/secondaryupload" component={SecondaryUpload} />
      <Route path="/cycleCount" component={CycleCount} />
	  <Route path="/maintenance" component={Binconsolidation} />
      <Route path="/picking" component={Picking} />
      <Route path="/WMSReports" component={ReportsForm} />
      <Route path="/productIT" component={ProductIT} />
      <Route path="/stockManagement" component={StockMovement} />
      <Route path="/history" component={History} />
      <Route path="/fastmovinglastdetail" component={FastMovingLastDetail} />
      <Route path="/slowmovinglastdetail" component={SlowMovingLastDetail} />
      <Route path="/binconsolidationcandidatesdetail" component={BinConsolidationCandidatesDetail} />
      <Route path="/shelflifedetail" component={ShelfLifeDetail} />
	  <Route path="/PickingProductivityDetail" component={PickingProductivityDetail} />

      <Route path="/tables" component={Tables} />
      <Route path="/charts" component={Charts} />
      <Route path="/maps" component={Maps} />
      <Route path="/account" component={Account} />
      <Route path="/e-commerce" component={ECommerce} />
      <Route path="/default_pages" component={DefaultPages} />
      <Route path="/documentation" component={Documentation} />

    </div>
  </div>
);
